module.exports = __webpack_public_path__ + "img/help-btn.4ebd6387.png";